import { render, staticRenderFns } from "./perfectInformation-list.vue?vue&type=template&id=7bca98df&scoped=true"
import script from "./perfectInformation-list.vue?vue&type=script&lang=js"
export * from "./perfectInformation-list.vue?vue&type=script&lang=js"
import style0 from "./perfectInformation-list.vue?vue&type=style&index=0&id=7bca98df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bca98df",
  null
  
)

export default component.exports